import React from 'react'
import CustomerDetails from '../../../Components/Organisms/Customers/CustomerDetails'

function CustomerDetailsTemplate({customerData, roles}) {
  return (
    <CustomerDetails customerData={customerData} roles={roles} />
  )
}

export default CustomerDetailsTemplate